import { useState } from "react";
// import styles from "./todoList.module.css";
import Todo from "./Todo";

const TodoList = ({ todos }) => {
  const renderTodos = () => {
    if (todos.length === 0) return;
    console.log("toodos=>", todos);
    return todos.map(todo => {
      return <Todo key={todo.id} todo={todo} />;
    });
  };

  return <div className="row">{renderTodos()}</div>;
};

export default TodoList;
